import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colFormRef, colFieldRef } from './consts';

export default grapesjs.plugins.add('gjs-collection-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'collection-form',
    blocks: [colFormRef, colFieldRef],
    defaultStyle: true,
    labelColForm: 'Collection Form',
    labelColField: 'Collection Field',
    labelColFileDropzone: 'File Upload',
    labelColFormCategory: 'Forms',
    labelColFieldCategory: 'Forms',
    labelColFileDropzoneCategory: 'Forms',
    labelTraitMethod: 'Method',
    labelTraitAction: 'Action',
    labelColName: 'Collection',
    labelColFieldName: 'Collection Field',
    labelColFileDropzoneName: 'File Upload',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
  loadTraits(editor, c);
});
